import { HelpTip, useSuggestionDecisions, VersionSuggestionsReviewCard } from '@dataroom/shared';
import { useResolveVersionSuggestions, useVersionSuggestions } from '@/api/hooks';

interface ReviewProps {
  roomId: string;
  /** Open a document (the in-app preview) so the two files can be compared. */
  onOpenDocument?: (documentId: string) => void;
  /** Start expanded (tests and the harness); the room page starts collapsed. */
  defaultExpanded?: boolean;
}

/**
 * The room's "Possible new versions" (ADR-0031) on the data room page: the
 * shared compact list (one-line summary → strong-first rows with bulk Merge /
 * Keep separate) fed by the admin's own hooks. The seller portal shows the same
 * list.
 */
export function VersionSuggestionsReview({ roomId, onOpenDocument, defaultExpanded }: ReviewProps) {
  const query = useVersionSuggestions(roomId);
  const resolve = useResolveVersionSuggestions(roomId);
  const decisions = useSuggestionDecisions(resolve.mutateAsync);
  return (
    <VersionSuggestionsReviewCard
      suggestions={query.data}
      decisions={decisions}
      onOpenDocument={onOpenDocument}
      defaultExpanded={defaultExpanded}
      titleAside={<HelpTip id="admin.data.version-suggestions" />}
    />
  );
}
